import React, {
  Fragment,
  useContext,
  useEffect,
  useState,
  useRef,
  useMemo,
  useCallback,
} from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { Link, Redirect } from "react-router-dom";
import { ServiciosContext } from "../../../context/ServiciosContext";
import { ConfiguracionContext } from "../../../context/ConfiguracionContext";
import { AuthContext } from "../../../context/AuthContext";
import { Button } from "primereact/button";
import Spinner from "../Spinner";
import { ToggleButton } from "primereact/togglebutton";
import { Badge } from "primereact/badge";
import { Tooltip } from "primereact/tooltip";
import { Toast } from "primereact/toast";
import { styled } from "@mui/material/styles";
import { Navigate, useNavigate } from "react-router-dom";
import "../../../assets/css/ResumenMoviles.css";

const MOVIL_COLOR_CLASS = {
  ROJO: "rojo",
  AMARILLO: "amarillo",
  VERDE: "verde",
  AZUL: "azul",
  CELESTE: "celeste",
  NARANJA: "naranja",
  FUCCIA: "fuccia",
  BLANCO: "blanco",
  NEGRO: "negro",
  MARRON: "marron",
};

const colorChipClass = (color) =>
  "movil-chip" +
  (MOVIL_COLOR_CLASS[color] ? " " + MOVIL_COLOR_CLASS[color] : "");

export default function ResumenMoviles(props) {
  //const classes = useStyles();
  const loaded = useRef(false);
  const [loop, setLoop] = useState(null);
  const [band, setBand] = useState(false);
  const [band2, setBand2] = useState(false);
  const [tripula, setTripula] = useState([]);
  const [derivado, setDerivado] = useState([]);
  const [checked, setChecked] = useState(true);
  const [busquedaDerivado, setBusquedaDerivado] = useState("");
  const [distancia, setDistancia] = useState(0);
  const [bandStart, setBandStart] = useState(false);

  const serviciosContext = useContext(ServiciosContext);
  const {
    tripulaciones,
    despachosAsignados,
    selectedRow,
    servicio,
    refrescar,
    movilMarcado,
    servicioSeleccionado,
    movilesDerivados,
    obtenerTripulaciones,
    obtenerServiciosPendientes,
    obtenerServiciosAsignados,
    asignarMovil,
    asignarMovilDerivado,
    guardarServicioSeleccionado,
    setOpenDrawer,
    setMovilMarcado,
    setRefrescar,
    obtenerMovilesDerivados,
    guardarMovilesDerivados,
    setOpenMp,
    setBandMp,
    setSelectedRow,
  } = serviciosContext;

  const configuracionContext = useContext(ConfiguracionContext);
  const {
    configuracion,
    colores,
    medicosRecetas,
    obtenerColores,
    zonasMovilesDerivados,
    obtenerZonasMovilesDerivados,
    obtenerMedicosRecetas,
  } = configuracionContext;

  const authContext = useContext(AuthContext);
  const { state } = authContext;

  const options = ["Propios", "Derivados"];
  const toastBC = useRef(null);
  const toastTC = useRef(null);

  //const classes = useStyles({color: afiliado ? afiliado.motivoConsultaColor : null });

  useEffect(() => {
    obtenerTripulaciones({ estado: false });
    obtenerMovilesDerivados();
    obtenerServiciosPendientes();
    obtenerServiciosAsignados();
    obtenerZonasMovilesDerivados();
    obtenerColores();
    setBand(true);
    setBand2(true);
    window.addEventListener("storage", onStorageUpdate);
    return () => {
      window.removeEventListener("storage", onStorageUpdate);
    };
  }, []);

  useEffect(() => {
    let interval = setInterval(() => {
      obtenerTripulaciones({ estado: false });
      obtenerMovilesDerivados();
      obtenerServiciosPendientes();
      obtenerServiciosAsignados();
      obtenerZonasMovilesDerivados();
      obtenerColores();
      setBand(true);
      setBand2(true);
    }, 30000);

    return () => clearTimeout(interval);
  }, []);

  // Recalcular el panel cuando llegan datos nuevos de móviles o servicios asignados
  useEffect(() => {
    setBand(true);
    setBand2(true);
  }, [tripulaciones, despachosAsignados]);

  useEffect(() => {
    if (
      servicioSeleccionado &&
      servicioSeleccionado.color === "BLANCO" &&
      configuracion &&
      (configuracion.destinatario === 4 ||
        configuracion.destinatario === 5 ||
        configuracion.destinatario === 6) &&
      configuracion.institucionId
    ) {
      obtenerMedicosRecetas({
        institucionId: configuracion.institucionId,
      });
    }
  }, [servicioSeleccionado]);

  /*
  if (!bandStart) {
    setTimeout(() => {
      handleStart();
    }, 30000);
    setBandStart(true);
  }
  */

  const onStorageUpdate = (e) => {
    const { key, newValue } = e;
    if (key === "refrescar") {
      setTimeout(() => {
        setRefrescar(newValue);
      }, 2000);
    }
  };

  /*
  const handleStart = () => {
    let interval = setInterval(() => {
      //obtenerTripulaciones({ estado: false });
      //console.log('handle')
      obtenerTripulaciones({ estado: false });
      obtenerMovilesDerivados();
      obtenerServiciosPendientes();
      obtenerZonasMovilesDerivados();
      //obtenerColores();
      setBand(true);
      //setBand2(true);
    }, 30000);
    setLoop(interval);
  };
  */

  const handleReset = () => {
    clearInterval(loop);
  };

  if (!loop) {
    //handleStart();
  }

  //const theme = useTheme();

  // Propios
  // El estado de cada móvil sale de despachosAsignados (lista sin filtrar),
  // no de despachos (que viene filtrada por zona/color/móvil de la grilla).
  if (band === true && tripulaciones && despachosAsignados && checked) {
    let trip = [];
    for (var i = 0; i < tripulaciones.length; i++) {
      if (!tripulaciones[i].activo) continue;

      const servicioAsignado = despachosAsignados.find(
        (d) => d.id === tripulaciones[i].servicioId,
      );

      trip.push({
        id: tripulaciones[i].id,
        movilId: tripulaciones[i].movilId,
        movil: tripulaciones[i].movil,
        detalle: tripulaciones[i].detalle,
        color: servicioAsignado ? servicioAsignado.color : "",
        medicoEstado: tripulaciones[i].medicoEstado,
        choferEstado: tripulaciones[i].choferEstado,
        enfermeroEstado: tripulaciones[i].enfermeroEstado,
        lat: tripulaciones[i].lat,
        lon: tripulaciones[i].lon,
        fechaGps: tripulaciones[i].fechaGps,
        token: tripulaciones[i].token,
        estado: servicioAsignado ? servicioAsignado.estado : "",
        distancia: "",
        indicativo: servicioAsignado ? servicioAsignado.id : "",
        medico: tripulaciones[i].medico,
        chofer: tripulaciones[i].chofer,
        enfermero: tripulaciones[i].enfermero,
        telefonoId: tripulaciones[i].telefonoId,
        cantidadServiciosPendientes:
          tripulaciones[i].cantidadServiciosPendientes,
        cantidadServiciosFinalizados:
          tripulaciones[i].cantidadServiciosFinalizados,
      });
    }

    if (trip.length > 0) {
      trip.sort(function (a, b) {
        return a.movilId - b.movilId;
      });
      setTripula(trip);
    } else {
      console.log("No hay datos");
    }
    setBand(false);
  }

  //Derivados
  if (band2 === true && movilesDerivados && despachosAsignados && !checked) {
    let zona = [];
    if (zonasMovilesDerivados.length > 0 && servicioSeleccionado) {
      for (var i = 0; i < zonasMovilesDerivados.length; i++) {
        zona.push({
          id: zonasMovilesDerivados[i].id,
          movil: zonasMovilesDerivados[i].movilId,
          lat: zonasMovilesDerivados[i].lat,
          lon: zonasMovilesDerivados[i].lon,
          distancia: distanciaKm(
            Number(zonasMovilesDerivados[i].lat),
            Number(zonasMovilesDerivados[i].lon),
            Number(servicioSeleccionado.lat),
            Number(servicioSeleccionado.lon),
          ),
        });
      }

      zona.sort(function (a, b) {
        return a.distancia - b.distancia;
      });
    } else {
      //console.log("No hay datos");
    }

    let der = [];

    for (var i = 0; i < movilesDerivados.length; i++) {
      der.push({
        id: movilesDerivados[i].id,
        movil: movilesDerivados[i].id,
        detalle: movilesDerivados[i].detalle,
        nombre: movilesDerivados[i].nombre,
        telefono: movilesDerivados[i].telefono,
        color: "",
        estado: "",
        distancia: 999999,
        indicativo: "",
        derivadoServicioId: movilesDerivados[i].derivadoServicioId,
        recetarioId: movilesDerivados[i].recetarioId,
      });
    }

    for (var i = 0; i < der.length; i++) {
      for (var j = 0; j < zona.length; j++) {
        if (der[i].movil === zona[j].movil && der[i].distancia === 999999) {
          der[i].distancia = zona[j].distancia;
        }
      }
    }

    for (var i = 0; i < der.length; i++) {
      for (var j = 0; j < despachosAsignados.length; j++) {
        if (der[i].derivadoServicioId === despachosAsignados[j].id) {
          der[i].color = despachosAsignados[j].color;
          der[i].estado = despachosAsignados[j].estado;
          der[i].indicativo = despachosAsignados[j].id;
        }
      }
    }

    /*
    der.sort(function (a, b) {
      return a.distancia - b.distancia;
    });
    */

    if (configuracion.destinatario === 1) {
      der.sort((a, b) => {
        if (a.distancia !== b.distancia) {
          return a.distancia - b.distancia; // menor distancia primero
        }

        return a.id - b.id; // si la distancia es igual, ordenar por id
      });
    } else {
      der.sort((a, b) => {
        if (a.distancia !== b.distancia) {
          return a.distancia - b.distancia; // menor distancia primero
        }

        return a.nombre - b.nombre; // si la distancia es igual, ordenar por id
      });
    }
    setDerivado(der);
    setBand2(false);
  }

  function distanciaKm(lat1, lon1, lat2, lon2) {
    if (lat1 === null || lon1 === null || lat2 === null || lon2 === null) {
      return 0;
    }
    const R = 6371; // radio de la Tierra en km

    const toRad = (valor) => (valor * Math.PI) / 180;

    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) *
        Math.cos(toRad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return Number((R * c).toFixed(2));
  }

  const movilSeleccionado = (elem) => {
    if (
      servicioSeleccionado &&
      (servicioSeleccionado.color === "VERDE" ||
        servicioSeleccionado.color === "AMARILLO" ||
        servicioSeleccionado.color === "ROJO") &&
      colores.some(
        (item) =>
          item.nombre === servicioSeleccionado.color &&
          item.espera != null &&
          Number(item.espera) !== 0,
      )
    ) {
      const tripulaConDistancia = tripula.map((item) => {
        const puntosValidos =
          item.lat != null &&
          item.lon != null &&
          servicioSeleccionado &&
          servicioSeleccionado.lat != null &&
          servicioSeleccionado.lon != null;
        return {
          ...item,
          distancia: puntosValidos
            ? distanciaKm(
                Number(item.lat),
                Number(item.lon),
                Number(servicioSeleccionado.lat),
                Number(servicioSeleccionado.lon),
              )
            : 0,
        };
      });

      const movilesLlegada = tripulaConDistancia.filter(
        (item) =>
          item.estado === "LLEGADA" &&
          ["VERDE", "AMARILLO", "ROJO"].includes(item.color),
      );

      const distanciaMovilSeleccionado =
        elem.lat == null ||
        elem.lon == null ||
        servicioSeleccionado.lat == null ||
        servicioSeleccionado.lon == null
          ? 0
          : distanciaKm(
              elem.lat,
              elem.lon,
              servicioSeleccionado.lat,
              servicioSeleccionado.lon,
            );

      // Llegada (del array despachosAsignados) de los servicios cuyo id coincide con el
      // campo indicativo de cada móvil de movilesLlegada.
      const llegadasMovilesLlegada = movilesLlegada.map((m) => {
        const despacho = despachosAsignados.find((d) => d.id === m.indicativo);
        const llegada = despacho ? despacho.llegada : null;

        let diferenciaMinutos = null;
        if (llegada) {
          const [fecha, hora] = llegada.substring(0, 16).split(" ");
          const [dd, mm, yyyy] = fecha.split("/");
          const [hh, min] = hora.split(":");
          const fLlegada = new Date(yyyy, mm - 1, dd, hh, min);
          diferenciaMinutos = Math.round(
            (Date.now() - fLlegada.getTime()) / 60000,
          );
        }

        const colorInfo = colores
          ? colores.find((c) => c.nombre === m.color)
          : null;
        const espera = colorInfo ? Number(colorInfo.espera) : null;
        const minutosFinal =
          espera != null && diferenciaMinutos != null
            ? Math.max(0, espera - diferenciaMinutos)
            : null;

        return {
          indicativo: m.indicativo,
          movil: m.movil,
          color: m.color,
          llegada,
          diferenciaMinutos,
          espera,
          minutosFinal,
          distancia: m.distancia,
        };
      });

      // Móviles en LLEGADA que están más cerca del servicio que el móvil elegido.
      const movilesMasCerca = llegadasMovilesLlegada.filter(
        (m) => m.distancia < distanciaMovilSeleccionado + 3,
      );

      if (toastTC.current && movilesMasCerca.length > 0) {
        const detalle = (
          <div
            style={{ display: "flex", flexDirection: "column", gap: "0.35rem" }}
          >
            {movilesMasCerca.map((m, i) => (
              <div key={i}>
                {`${m.movil} (Ind. ${m.indicativo}, ${m.color}) — finaliza en ~${m.minutosFinal} min · a ${m.distancia} km del destino`}
              </div>
            ))}
          </div>
        );
        toastTC.current.show({
          severity: "info",
          summary: "Móviles próximos a finalizar",
          detail: detalle,
          sticky: true,
        });
      }
    }

    if (configuracion.destinatario === 1) {
      /*
      const index = tripula.findIndex((elem) => elem.estado === "");
      if (elem.id >=1000 && index !== -1) {
        toastBC.current.show({
          severity: "warn",
          summary: "Derivado",
          detail: `No puede derivar servicios a prestadores con móviles propios liberados. !!!`,
          life: 3000,
        });
        return;
      }
      */
      /*
      if (elem.id === 1079) {
        if (
          servicioSeleccionado.domicilio.toUpperCase().search("LAFERRERE") !==
            -1 ||
          servicioSeleccionado.localidad.toUpperCase().search("LAFERRERE") !==
            -1 ||
          servicioSeleccionado.domicilio.toUpperCase().search("CASANOVA") !==
            -1 ||
          servicioSeleccionado.localidad.toUpperCase().search("CASANOVA") !==
            -1 ||
          servicioSeleccionado.domicilio.toUpperCase().search("CASTILLO") !==
            -1 ||
          servicioSeleccionado.localidad.toUpperCase().search("CASTILLO") !==
            -1 ||
          servicioSeleccionado.domicilio.toUpperCase().search("EVITA") !== -1 ||
          servicioSeleccionado.localidad.toUpperCase().search("EVITA") !== -1 ||
          servicioSeleccionado.domicilio.toUpperCase().search("SAN JUSTO") !==
            -1 ||
          servicioSeleccionado.localidad.toUpperCase().search("SAN JUSTO") !==
            -1
        ) {
          toastBC.current.show({
            severity: "warn",
            summary: "Derivado",
            detail: `Este prestador no puede tomar servicios en esta zona. !!!`,
            life: 3000,
          });
          return;
        }
      }
      */
    }

    if (
      servicioSeleccionado &&
      servicioSeleccionado.traslados !== undefined &&
      servicioSeleccionado.traslados !== null &&
      servicioSeleccionado.traslados.destino === "Desconocido"
    ) {
      toastBC.current.show({
        severity: "warn",
        summary: "Traslado",
        detail: `El traslado tiene destino Desconocido.`,
        life: 3000,
      });
      return;
    }

    if (movilMarcado === elem.movilId) {
      setMovilMarcado(null);
      var element = document.getElementById("hiddenButton");
      element.focus();
    } else {
      setMovilMarcado(elem.movilId);
    }

    if (elem.movilId < 1000) {
      if (
        servicioSeleccionado !== null &&
        servicioSeleccionado.movilId === null
      ) {
        if (
          colores &&
          colores.length > 0 &&
          servicioSeleccionado.color !== "" &&
          ((colores.find((x) => x.nombre === servicioSeleccionado.color)
            .medico &&
            elem.medicoEstado !== "INGRESO") ||
            (colores.find((x) => x.nombre === servicioSeleccionado.color)
              .chofer &&
              elem.choferEstado !== "INGRESO") ||
            (colores.find((x) => x.nombre === servicioSeleccionado.color)
              .enfermero &&
              elem.enfermeroEstado !== "INGRESO"))
        ) {
          toastBC.current.show({
            severity: "warn",
            summary: "Tripulación",
            detail: `La tripulación no cumple los requisitos para asignarle el servicio.`,
            life: 5000,
          });
          return;
        }

        let simultaneo = colores.find(
          (item) => item.nombre === servicioSeleccionado.color,
        ).simultaneo;

        if (!simultaneo && elem.color !== "") {
          toastBC.current.show({
            severity: "warn",
            summary: "Simultáneo",
            detail: `El color ${servicioSeleccionado.color} no acepta servicios simultáneos. El móvil ${elem.movilId} ya esta asistiendo un servicio.`,
            life: 5000,
          });
          return;
        }

        let bandSimultaneo = true;

        for (var i = 0; i < despachosAsignados.length; i++) {
          if (despachosAsignados[i].tripulacionId === elem.id) {
            let simultaneo = colores.find(
              (x) => x.nombre === despachosAsignados[i].color,
            ).simultaneo;
            if (!simultaneo) {
              bandSimultaneo = false;
              break;
            }
          }
        }

        if (!bandSimultaneo) {
          toastBC.current.show({
            severity: "warn",
            summary: "Simultáneo",
            detail: `El móvil ${elem.movilId} esta asistiendo un servicio que no acepta simultáneos.`,
            life: 5000,
          });
          return;
        }

        //console.log(e);
        toastBC.current.show({
          severity: "warn",
          sticky: true,
          className: "resumen-confirm-toast",
          content: (
            <div className="resumen-confirm">
              <div className="resumen-confirm-icon">
                <i className="pi pi-exclamation-triangle"></i>
              </div>
              <h4 className="resumen-confirm-title">{`Esta seguro de asignar el móvil ${elem.movilId} al indicativo ${servicioSeleccionado.id} ?`}</h4>
              <p className="resumen-confirm-sub">{`Tripulacion : ${elem.medico} - ${elem.chofer} - ${elem.enfermero}`}</p>
              <div className="resumen-confirm-actions">
                <Button
                  type="button"
                  label="Si"
                  icon="pi pi-check"
                  className="p-button-success resumen-confirm-btn"
                  onClick={(e) =>
                    opcionSiPasado(
                      elem.id,
                      servicioSeleccionado.id,
                      elem.movilId,
                      servicioSeleccionado.color,
                      servicioSeleccionado.grupo,
                      elem.nombre,
                      elem.token,
                      elem.telefonoId,
                    )
                  }
                />
                <Button
                  type="button"
                  label="No"
                  icon="pi pi-times"
                  className="p-button-danger p-button-outlined resumen-confirm-btn"
                  onClick={opcionNo}
                />
              </div>
            </div>
          ),
        });
      } else {
        toastBC.current.show({
          severity: "info",
          summary: "Info Tripulación",
          detail: `Médico: ${elem.medico} Chofer: ${elem.chofer} Enfermero: ${elem.enfermero}`,
          life: 3000,
        });
      }
    }

    if (elem.movil >= 1000) {
      //console.log(servicioSeleccionado)

      let medicoReceta = null;

      if (
        configuracion.institucionId &&
        servicioSeleccionado.color === "BLANCO"
      ) {
        let index = derivado.findIndex((item) => item.id === elem.movil);
        //console.log(derivado[index])
        if (!derivado[index].telefono) {
          toastBC.current.show({
            severity: "warn",
            summary: "Telemedicina",
            detail: `El móvil no tiene asignado un celular.`,
            life: 3000,
          });
          return;
        }

        if (!derivado[index].recetarioId) {
          toastBC.current.show({
            severity: "warn",
            summary: "Telemedicina",
            detail: `El móvil no tiene asignado un medico para telemedicina.`,
            life: 3000,
          });
          return;
        }

        let indexReceta = medicosRecetas.findIndex(
          (item) => item.id === derivado[index].recetarioId,
        );

        if (indexReceta === -1) {
          toastBC.current.show({
            severity: "warn",
            summary: "Telemedicina",
            detail: `Error en la captura del médico.`,
            life: 3000,
          });
          return;
        }

        let activoRecetario = medicosRecetas[indexReceta].active;
        medicoReceta =
          medicosRecetas[indexReceta].name +
          " " +
          medicosRecetas[indexReceta].surname;

        if (!activoRecetario) {
          toastBC.current.show({
            severity: "warn",
            summary: "Telemedicina",
            detail: `El médico asignado (${medicoReceta}) no esta activo para generar recetas.`,
            life: 3000,
          });
          return;
        }

        //console.log(medicosRecetas)
      }

      if (
        servicioSeleccionado !== null &&
        servicioSeleccionado.movilId === null
      ) {
        toastBC.current.show({
          severity: "warn",
          sticky: true,
          className: "resumen-confirm-toast",
          content: (
            <div className="resumen-confirm">
              <div className="resumen-confirm-icon">
                <i className="pi pi-exclamation-triangle"></i>
              </div>
              <h4 className="resumen-confirm-title">{`Esta seguro de asignar el móvil ${elem.movil} al indicativo ${servicioSeleccionado.id} ?`}</h4>
              <p className="resumen-confirm-sub">{`Móvil : ${elem.nombre} - ${elem.detalle}`}</p>
              {(configuracion.destinatario === 4 ||
                configuracion.destinatario === 5 ||
                configuracion.destinatario === 6) &&
              servicioSeleccionado.color === "BLANCO" ? (
                <p className="resumen-confirm-sub">{`${medicoReceta} `}</p>
              ) : null}
              <div className="resumen-confirm-actions">
                <Button
                  type="button"
                  label="Si"
                  icon="pi pi-check"
                  className="p-button-success resumen-confirm-btn"
                  onClick={(e) =>
                    opcionSiPasado(
                      elem.id,
                      servicioSeleccionado.id,
                      elem.movil,
                      servicioSeleccionado.color,
                      servicioSeleccionado.grupo,
                      elem.nombre,
                      elem.token,
                      elem.telefonoId,
                    )
                  }
                />
                <Button
                  type="button"
                  label="No"
                  icon="pi pi-times"
                  className="p-button-danger p-button-outlined resumen-confirm-btn"
                  onClick={opcionNo}
                />
              </div>
            </div>
          ),
        });
      } else {
        let zonas = [];
        zonas = zonasMovilesDerivados.filter(
          (item) => item.movilId === elem.movilId,
        );
        let detail = "Zonas de cobertura ";
        for (var i = 0; i < zonas.length; i++) {
          detail = detail + zonas[i].localidad + " ";
        }
        toastBC.current.show({
          severity: "info",
          summary: "Móvil Derivado",
          detail: detail,
          life: 5000,
        });
      }
    }
  };

  const opcionSiPasado = (
    tripulacion,
    servicio,
    movil,
    color,
    grupo,
    detalleDerivado,
    token,
    telefonoId,
  ) => {

    if (movil < 1000) {
      asignarMovil({
        tripulacionId: tripulacion,
        movil,
        color,
        grupo,
        servicioId: servicio,
        usuario: state.usuario.usuario,
        indicativoEmisor: servicioSeleccionado.indicativoEmisor,
        titularId: servicioSeleccionado.titularId,
        nombre: servicioSeleccionado.nombre,
        conf: configuracion,
      });
    } else {
      asignarMovilDerivado({
        movil,
        color,
        servicioId: servicio,
        usuario: state.usuario.usuario,
        indicativoEmisor: servicioSeleccionado.indicativoEmisor,
        titularId: servicioSeleccionado.titularId,
        detalleDerivado,
        nombre: servicioSeleccionado.nombre,
        institucionId: configuracion.institucionId,
        destinatario: configuracion.destinatario,
        pantalla: configuracion.telemedicinapantalla,
        conf: configuracion,
      });
    }
    toastBC.current.clear();
    guardarServicioSeleccionado(null);
    setOpenDrawer(false);
    setSelectedRow(null);
    // El dialog de envío por WhatsApp solo aplica a destinatario 6
    if (
      servicioSeleccionado.linkMp &&
      configuracion &&
      configuracion.destinatario === 6
    ) {
      setOpenMp(true);
    }
  };

  const opcionSiSalida = (servicio) => {
    //console.log(servicio);
  };

  function opcionNo() {
    toastBC.current.clear();
    setOpenDrawer(false);
  }

  const normalizarTextoBusqueda = (valor) =>
    (valor || "")
      .toString()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();

  const derivadosFiltrados = useMemo(() => {
    const busqueda = normalizarTextoBusqueda(busquedaDerivado);

    if (!busqueda) return derivado;

    return derivado.filter((element) =>
      [
        element.movil,
        element.nombre,
        element.detalle,
        element.telefono,
        element.indicativo,
        element.estado,
        element.color,
      ]
        .map(normalizarTextoBusqueda)
        .some((valor) => valor.includes(busqueda)),
    );
  }, [derivado, busquedaDerivado]);

  //console.log(tripula)

  return (
    <Fragment>
      {colores &&
      colores.length > 0 &&
      ((tripula && tripula.length > 0) || (derivado && derivado.length > 0)) ? (
        <Grid
          container
          spacing={0}
          style={{
            marginTop: "-6em",
            marginLeft: "1em",
            paddingLeft: "0em",
            alignItems: "normal",
          }}
        >
          <Toast ref={toastBC} position="top-right" />
          <Toast ref={toastTC} position="top-center" />
          <Button
            id="hiddenButton"
            style={{ backgroundColor: "white", opacity: 0, height: "0.1vw" }}
            className="p-button-rounded"
          />
          <Grid
            item
            xs={12}
            md={12}
            style={{ marginTop: "6em", marginLeft: "3em" }}
          >
            <ToggleButton
              className="resumen-moviles-toggle"
              onLabel="Propios"
              offLabel="Derivados"
              onIcon="pi pi-arrow-circle-down"
              offIcon="pi pi-arrow-circle-up"
              checked={checked}
              onChange={(e) => setChecked(e.value)}
            />
          </Grid>

          {checked && tripula ? (
            <Fragment>
              <Grid item xs={12} md={12} style={{ marginTop: "0em" }}>
                <div className="resumen-section-title">
                  <i className="pi pi-unlock" />
                  <span>Liberados</span>
                  <span className="resumen-section-count">
                    {tripula.filter((e) => e.color === "").length}
                  </span>
                </div>
              </Grid>

              {tripula.map((element) => {
                let totalServicios =
                  Number(element.cantidadServiciosFinalizados) +
                  Number(element.cantidadServiciosPendientes);

                if (element.color === "") {
                  const km =
                    servicioSeleccionado !== null &&
                    element.lat !== null &&
                    element.lon !== null &&
                    servicioSeleccionado.lat !== null &&
                    servicioSeleccionado.lon !== null
                      ? distanciaKm(
                          Number(element.lat),
                          Number(element.lon),
                          Number(servicioSeleccionado.lat),
                          Number(servicioSeleccionado.lon),
                        ) + " Km"
                      : null;

                  return (
                    <Grid item xs={12} md={12} style={{ marginTop: "0em" }}>
                      <div className="movil-row">
                        <Button
                          label={
                            (element.detalle?.trim()
                              ? element.detalle
                              : element.movilId) +
                            " ( " +
                            Number(totalServicios) +
                            " )"
                          }
                          icon={
                            element.medicoEstado === "PENDIENTE" &&
                            element.choferEstado === "PENDIENTE" &&
                            element.enfermeroEstado === "PENDIENTE"
                              ? "pi pi-info-circle"
                              : null
                          }
                          className="p-button-rounded p-button-sm movil-chip libre"
                          disabled={
                            servicioSeleccionado &&
                            colores &&
                            colores.length > 0 &&
                            ((colores.find(
                              (x) => x.nombre === servicioSeleccionado.color,
                            ).medico === "SI" &&
                              element.medicoEstado === "PENDIENTE") ||
                              (colores.find(
                                (x) => x.nombre === servicioSeleccionado.color,
                              ).chofer === "SI" &&
                                element.choferEstado === "PENDIENTE") ||
                              (colores.find(
                                (x) => x.nombre === servicioSeleccionado.color,
                              ).enfermero === "SI" &&
                                element.enfermeroEstado === "PENDIENTE"))
                          }
                          onClick={(e) => movilSeleccionado(element)}
                          /*
                  tooltip={
                    servicioSeleccionado &&
                    colores &&
                    ((colores.find(
                        (x) => x.nombre === servicioSeleccionado.color
                      ).medico === "SI" &&
                        element.medicoEstado === "PENDIENTE") ||
                      (colores.find(
                        (x) => x.nombre === servicioSeleccionado.color
                      ).chofer === "SI" &&
                        element.choferEstado === "PENDIENTE") ||
                      (colores.find(
                        (x) => x.nombre === servicioSeleccionado.color
                      ).enfermero === "SI" &&
                        element.enfermeroEstado === "PENDIENTE"))
                      ? "Tripulación incompleta"
                      : null
                  }
                  tooltipOptions={{
                    position: "right",
                    mouseTrack: true,
                    mouseTrackTop: 15,
                    className: classes.tooltip,
                  }}
                  */
                        />
                        {km ? (
                          <Badge className="movil-badge-km" value={km}></Badge>
                        ) : null}
                      </div>
                    </Grid>
                  );
                }
              })}

              <Grid item xs={12} md={12} style={{ marginTop: "0em" }}>
                <div className="resumen-section-title">
                  <i className="pi pi-phone" />
                  <span>Pasados</span>
                  <span className="resumen-section-count">
                    {
                      tripula.filter(
                        (e) =>
                          e.color !== "" &&
                          e.estado.substring(0, 6) === "PASADO",
                      ).length
                    }
                  </span>
                </div>
              </Grid>
              {tripula.map((element) => {
                let totalServicios =
                  Number(element.cantidadServiciosFinalizados) +
                  Number(element.cantidadServiciosPendientes);

                if (
                  element.color !== "" &&
                  element.estado.substring(0, 6) === "PASADO"
                ) {
                  const km =
                    servicioSeleccionado !== null &&
                    element.lat !== null &&
                    element.lon !== null &&
                    servicioSeleccionado.lat !== null &&
                    servicioSeleccionado.lon !== null
                      ? distanciaKm(
                          Number(element.lat),
                          Number(element.lon),
                          Number(servicioSeleccionado.lat),
                          Number(servicioSeleccionado.lon),
                        ) + " Km"
                      : null;

                  return (
                    <Grid item xs={12} md={12} style={{ marginTop: "0em" }}>
                      <div className="movil-row">
                        <Button
                          label={
                            (element.detalle?.trim()
                              ? element.detalle
                              : element.movilId) +
                            " ( " +
                            Number(totalServicios) +
                            " )"
                          }
                          className={
                            "p-button-rounded p-button-sm " +
                            colorChipClass(element.color)
                          }
                          onClick={(e) => movilSeleccionado(element)}
                        />
                        {km ? (
                          <Badge className="movil-badge-km" value={km}></Badge>
                        ) : null}
                        <Badge
                          value={"Ind. " + element.indicativo}
                          severity="success"
                        ></Badge>
                      </div>
                    </Grid>
                  );
                }
              })}

              <Grid item xs={12} md={12} style={{ marginTop: "0em" }}>
                <div className="resumen-section-title">
                  <i className="pi pi-send" />
                  <span>Salida</span>
                  <span className="resumen-section-count">
                    {
                      tripula.filter(
                        (e) =>
                          e.color !== "" &&
                          e.estado.substring(0, 6) === "SALIDA",
                      ).length
                    }
                  </span>
                </div>
              </Grid>
              {tripula.map((element) => {
                let totalServicios =
                  Number(element.cantidadServiciosFinalizados) +
                  Number(element.cantidadServiciosPendientes);

                if (
                  element.color !== "" &&
                  element.estado.substring(0, 6) === "SALIDA"
                ) {
                  const km =
                    servicioSeleccionado !== null &&
                    element.lat !== null &&
                    element.lon !== null &&
                    servicioSeleccionado.lat !== null &&
                    servicioSeleccionado.lon !== null
                      ? distanciaKm(
                          Number(element.lat),
                          Number(element.lon),
                          Number(servicioSeleccionado.lat),
                          Number(servicioSeleccionado.lon),
                        ) + " Km"
                      : null;

                  return (
                    <Grid item xs={12} md={12} style={{ marginTop: "0em" }}>
                      <div className="movil-row">
                        <Button
                          label={
                            (element.detalle?.trim()
                              ? element.detalle
                              : element.movilId) +
                            " ( " +
                            Number(totalServicios) +
                            " )"
                          }
                          className={
                            "p-button-rounded p-button-sm " +
                            colorChipClass(element.color)
                          }
                          onClick={(e) => movilSeleccionado(element)}
                        />
                        {km ? (
                          <Badge className="movil-badge-km" value={km}></Badge>
                        ) : null}
                        <Badge
                          value={"Ind. " + element.indicativo}
                          severity="success"
                        ></Badge>
                      </div>
                    </Grid>
                  );
                }
              })}

              <Grid item xs={12} md={12} style={{ marginTop: "0em" }}>
                <div className="resumen-section-title">
                  <i className="pi pi-flag" />
                  <span>Llegada</span>
                  <span className="resumen-section-count">
                    {
                      tripula.filter(
                        (e) => e.color !== "" && e.estado === "LLEGADA",
                      ).length
                    }
                  </span>
                </div>
              </Grid>
              {tripula.map((element) => {
                let totalServicios =
                  Number(element.cantidadServiciosFinalizados) +
                  Number(element.cantidadServiciosPendientes);

                if (element.color !== "" && element.estado === "LLEGADA") {
                  const km =
                    servicioSeleccionado !== null &&
                    element.lat !== null &&
                    element.lon !== null &&
                    servicioSeleccionado.lat !== null &&
                    servicioSeleccionado.lon !== null
                      ? distanciaKm(
                          Number(element.lat),
                          Number(element.lon),
                          Number(servicioSeleccionado.lat),
                          Number(servicioSeleccionado.lon),
                        ) + " Km"
                      : null;

                  return (
                    <Grid item xs={12} md={12} style={{ marginTop: "0em" }}>
                      <div className="movil-row">
                        <Button
                          label={
                            (element.detalle?.trim()
                              ? element.detalle
                              : element.movilId) +
                            " ( " +
                            Number(totalServicios) +
                            " )"
                          }
                          className={
                            "p-button-rounded p-button-sm " +
                            colorChipClass(element.color)
                          }
                          onClick={(e) => movilSeleccionado(element)}
                        />
                        {km ? (
                          <Badge className="movil-badge-km" value={km}></Badge>
                        ) : null}
                        <Badge
                          value={"Ind. " + element.indicativo}
                          severity="success"
                        ></Badge>
                      </div>
                    </Grid>
                  );
                }
              })}
            </Fragment>
          ) : null}

          {!checked && derivado ? (
            <Fragment>
              <Grid item xs={12} md={12} style={{ marginTop: "1em" }}>
                <TextField
                  label="Buscar prestador"
                  variant="outlined"
                  size="small"
                  value={busquedaDerivado}
                  onChange={(e) => setBusquedaDerivado(e.target.value)}
                  InputProps={{
                    endAdornment: busquedaDerivado ? (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="Limpiar busqueda"
                          size="small"
                          onClick={() => setBusquedaDerivado("")}
                        >
                          <ClearIcon fontSize="small" />
                        </IconButton>
                      </InputAdornment>
                    ) : null,
                  }}
                  fullWidth
                />
              </Grid>

              {derivadosFiltrados.map((element) => {
                if (
                  element.color !== "" &&
                  element.estado.substring(0, 6) === "PASADO"
                ) {
                  return (
                    <Grid item xs={12} md={12} style={{ marginTop: "0em" }}>
                      <div className="movil-row">
                        <Button
                          label={
                            element.nombre
                              ? element.movil + " " + element.nombre
                              : element.movil
                          }
                          className={
                            "p-button-rounded p-button-sm " +
                            colorChipClass(element.color)
                          }
                          onClick={(e) => movilSeleccionado(element)}
                        />
                        <Badge
                          value={"Ind. " + element.indicativo}
                          severity="success"
                        ></Badge>
                      </div>
                    </Grid>
                  );
                } else {
                  return (
                    <Grid item xs={12} md={12} style={{ marginTop: "0em" }}>
                      <div className="movil-row">
                        <Button
                          label={
                            element.nombre
                              ? element.movil + " " + element.nombre
                              : element.movil
                          }
                          className={
                            "p-button-rounded p-button-sm movil-chip " +
                            (Number(element.distancia) < 15 ? "cerca" : "lejos")
                          }
                          onClick={(e) => movilSeleccionado(element)}
                        />
                      </div>
                    </Grid>
                  );
                }
              })}

              {/*
              <Grid item xs={12} md={12} style={{ marginTop: "0em" }}>
                <h5>Pasados</h5>
              </Grid>
              {derivado.map((element) => {
                if (
                  element.color !== "" &&
                  element.estado.substring(0, 6) === "PASADO"
                ) {
                  return (
                    <Grid item xs={12} md={12} style={{ marginTop: "0em" }}>
                      <Button
                        label={
                          element.nombre
                            ? element.movil + " " + element.nombre
                            : element.movil
                        }
                        className="p-button-rounded p-button-outlined p-button-sm"
                        style={{
                          backgroundColor:
                            element.color === "ROJO"
                              ? "red"
                              : element.color === "AMARILLO"
                              ? "yellow"
                              : element.color === "VERDE"
                              ? "green"
                              : element.color === "AZUL"
                              ? "blue"
                              : element.color === "CELESTE"
                              ? "aqua"
                              : element.color === "NARANJA"
                              ? "orange"
                              : element.color === "FUCCIA"
                              ? "fuchsia"
                              : element.color === "BLANCO"
                              ? "white"
                              : element.color === "NEGRO"
                              ? "black"
                              : null,
                          color:
                            element.color === "ROJO" ||
                            element.color === "VERDE" ||
                            element.color === "AZUL" ||
                            element.color === "NEGRO"
                              ? "white"
                              : "black",
                        }}
                        onClick={(e) => movilSeleccionado(element)}
                      />
                      <Badge
                        value={"Ind. " + element.indicativo}
                        severity="success"
                      ></Badge>
                    </Grid>
                  );
                }
              })}
            */}
            </Fragment>
          ) : null}
        </Grid>
      ) : (
        <Spinner />
      )}
    </Fragment>
  );
}
